import React, { FunctionComponent } from 'react';
import { BrassLoader } from '../../components';

const IndicatorsPlayground: FunctionComponent = () => (
  <BrassLoader useLoadingMask type='infinite-spinner' />
);

export { IndicatorsPlayground };
